// extracted by mini-css-extract-plugin
module.exports = {"main":"page_main__sl1gu","sectionWrapper":"page_sectionWrapper__BYyJt"};